import type { AdditionalScreenerFilter } from '@/hooks/useInfiniteCompanyScreenersQuery/types';
import { getIndustryIdFromSlug, getMarkets } from '@/pages/Screener/functions';
import type { ParsedRule } from '@/pages/Screener/functions';
type GetAdditionalFiltersParams = {
  market: string;
  industry: string;
  isMarketInRules?: boolean;
};

export const isHavingMarketInRules = (rawRules: ParsedRule[]) => {
  const parsedRules = getMarkets(rawRules);
  return (
    parsedRules.countries.length > 0 || parsedRules.exchangeSymbols.length > 0
  );
};

export const getAdditionalFilters = ({
  market,
  industry,
  isMarketInRules = false,
}: GetAdditionalFiltersParams): AdditionalScreenerFilter[] => {
  const isMarketValueValid = market !== 'global' && !isMarketInRules;
  const marketValue = isMarketValueValid ? market : '';
  const industryId = getIndustryIdFromSlug(industry);
  return [
    {
      field: 'country_name',
      operator: 'in',
      logicalCondition: 'aor',
      values: [marketValue].filter(Boolean),
    },
    {
      field: 'primary_industry_id',
      operator: 'in',
      logicalCondition: 'aor',
      values: [industryId].filter(Boolean),
    },
  ];
};
